import Fab from '@/components/elements/forms/buttons/Fab/Fab';
import { usePinInput } from '@/components/elements/forms/PinInput/PinInput';
import Icon from '@/components/icons/Icon';
import { baseTranslationKey } from '@/components/modules/modals/LoginModal';
import CreateAccount from '@/components/templates/login/CreateAccount';
import RequestToken from '@/components/templates/login/RequestToken';
import VerifyOTP from '@/components/templates/login/VerifyOTP';
import VerifySuccess from '@/components/templates/login/VerifySuccess';
import { loginTrackingSession } from '@/helpers/loginTrackingSession';
import { useAppSelector } from '@/hooks';
import { LoginContext } from '@/hooks/useLogin';
import { _s } from '@/locale';

import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

const LoginPopover = () => {
  const context = useContext(LoginContext);
  const pinProps = usePinInput({ fields: 6, validateCallback: context.handleLogin });
  const user = useAppSelector((state) => state.users?.user);
  const { pathname } = useLocation();

  function handleOnBackClick() {
    loginTrackingSession.track({ step: 'back_to_email_submission', flow: context.flow });
    context.updateView('requestToken');
    context.clearLoginState();
  }

  useEffect(() => {
    if (user) context.updateView('verifySuccess');
  }, [user, context.view]);

  const contentView = (() => {
    switch (context.view) {
      case 'requestToken':
        return <RequestToken {...context} redirectUrl={pathname} autoFocus />;
      case 'createAccount':
        return <CreateAccount {...context} redirectUrl={pathname} />;
      case 'verifyOtp':
        return <VerifyOTP {...context} {...pinProps} />;
      case 'verifySuccess':
        return (
          <VerifySuccess
            {...context}
            onAnimationComplete={() => {
              context.onClose(false);
              context.clearLoginState();
            }}
          />
        );
    }
  })();

  const contentHeader = (() => {
    switch (context.view) {
      case 'requestToken':
        return (
          <Fragment>
            <div className="gap-lg pb-md flex items-start justify-between">
              <div className="bg-bg_info_bold grid place-content-center rounded-full" style={{ width: 56, height: 56 }}>
                <Icon variant="account" color="fg_alwaysLight" size="md" />
              </div>
            </div>

            <h2 className="text-fg_primary text-h-m">{_s(`${baseTranslationKey(context.view)}.title`)}</h2>
          </Fragment>
        );
      case 'createAccount':
        return (
          <Fragment>
            <div className="gap-lg flex items-start">
              <Fab
                onClick={handleOnBackClick}
                variant="secondary"
                icon={<Icon variant="back" />}
                size="md"
                aria-label={_s('back')}
              />
            </div>
            <h2 className="text-fg_primary text-h-m">{_s(`${baseTranslationKey(context.view)}.title`)}</h2>
          </Fragment>
        );
      case 'verifyOtp':
        return (
          <Fragment>
            <div className="gap-lg flex items-start">
              <Fab
                onClick={handleOnBackClick}
                variant="secondary"
                icon={<Icon variant="back" />}
                size="md"
                aria-label={_s('back')}
              />
            </div>
            <h2 className="text-fg_primary text-h-m">{_s(`${baseTranslationKey(context.view)}.title`)}</h2>
          </Fragment>
        );
      case 'verifySuccess':
        return <h2 className="text-fg_primary text-h-m">{_s(`${baseTranslationKey(context.view)}.title`)}</h2>;
    }
  })();

  return (
    <div className="bg-bg_neutral border-border_bold p-xl gap-md flex w-[340px] flex-col rounded-md border drop-shadow-lg">
      {contentHeader}
      {contentView}
    </div>
  );
};

export default LoginPopover;
